{
  "version": 1,
  "asset_id": "9199212a-c195-4549-9774-590aea4b47a2",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/9199212a-c195-4549-9774-590aea4b47a2/ss01-card-p3.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/9199212a-c195-4549-9774-590aea4b47a2/ss01-card-p3.webp",
  "original_filename": "ss01-card-p3.webp",
  "size": 181038,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:51Z"
}
